import { raw_boiler_models } from 'shared/app/model/boiler-models';
const boiler_models = Object.entries(raw_boiler_models).flatMap(
// @ts-ignore
([brand, models]) => models.flatMap((model) => Object.entries(model).map(([boiler_str_id, attributes]) => ({
    // @ts-ignore
    ...attributes,
    zont_id: boiler_str_id,
    brand,
}))));
export const boilerModelToNumber = Object.fromEntries(boiler_models.map((model) => [model.zont_id, model.id]));
export const boilerModelFromNumber = Object.fromEntries(boiler_models.map((model) => [model.id, model.zont_id]));
export function boilerTypeFromNumber(index) {
    return boilerModelFromNumber[index];
}
export const boilerAdapterProtocolForBaxi = Object.fromEntries(boiler_models
    .filter((model) => model.brand === 'BAXI')
    .map((model) => [model.zont_id, model.protocol]));
